// src/components/WarehouseDashboard.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import FavouriteButton from "./FavouriteButton";
import { useAuth } from "../firebase/AuthContext"; // <-- uses roles from claims/profile

// Icons
import bookinIcon from "./assets/signup-icon.png";
import warehouseIcon from "./assets/warehouse-icon.svg";
import moveIcon from "./assets/forklift-icon.png";
import archiveIcon from "./assets/product-return.png";

const WarehouseDashboard = () => {
  const navigate = useNavigate();
  const { currentUser, roles, profile } = useAuth();

  // roles from claims (authoritative), fallback to profile.roles
  const profileRoles = Array.isArray(profile?.roles) ? profile.roles : [];
  const effectiveRoles = roles?.length ? roles : profileRoles;

  const hasInternalOrAdmin =
    effectiveRoles.includes("admin") || effectiveRoles.includes("internal");
  const canViewDespatchWarehouseReport =
    effectiveRoles.includes("admin") || effectiveRoles.includes("warehouse");

  const baseTiles = [
    { title: "Book In", icon: bookinIcon, route: "/WarehouseBookingInForm" },
    { title: "View Warehouse Stock", icon: warehouseIcon, route: "/WarehouseView" },
    { title: "Book Out", icon: bookinIcon, route: "/WarehouseBookingOutForm" },
    { title: "Move Cylinders", icon: moveIcon, route: "/WarehouseMoveForm" },
    { title: "Dead Stock", icon: moveIcon, route: "/DeadStockView" },
    { title: "Warehouse Archive", icon: archiveIcon, route: "/WarehouseArchive"},
  ];

  const dynamicTiles = [];
  if (canViewDespatchWarehouseReport) {
    dynamicTiles.push({
      title: "Despatch and Warehouse Report",
      icon: warehouseIcon,
      route: "/DespatchWarehouseReport",
    });
    dynamicTiles.push({
      title: "Barcode Tracking",
      icon: warehouseIcon,
      route: "/BarcodeTracking",
    });
  }
  if (hasInternalOrAdmin) {
    dynamicTiles.push({ title: "Manual Book Out", icon: moveIcon, route: "/WarehouseAgedBookOut" });
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center p-6">
      {/* Favourite Button */}
      <FavouriteButton pageUrl={window.location.pathname} />

      {/* Title (show user name if available) */}
      <h1 className="text-4xl font-semibold text-gray-800 mb-8">
        Warehouse Dashboard{currentUser?.displayName ? ` — ${currentUser.displayName}` : ""}
      </h1>

      {/* Tiles */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-5xl">
        {[...baseTiles, ...dynamicTiles].map((tile, idx) => (
          <Tile
            key={idx}
            title={tile.title}
            icon={tile.icon}
            onClick={() => navigate(tile.route)}
          />
        ))}
      </div>
    </div>
  );
};

// Reusable tile
const Tile = ({ title, icon, onClick }) => (
  <div
    onClick={onClick}
    className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition cursor-pointer transform hover:-translate-y-1 flex flex-col items-center justify-center text-center w-full h-48 border border-gray-200"
  >
    <div className="flex justify-center items-center w-20 h-20 bg-gray-200 rounded-full group-hover:bg-primary transition">
      <img src={icon} alt={title} className="h-10 w-10 object-contain" />
    </div>
    <p className="mt-4 text-lg font-semibold text-gray-800 group-hover:text-primary transition">
      {title}
    </p>
  </div>
);

export default WarehouseDashboard;
